import { Activity, Shield, Zap, History } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SystemHealthCard } from "@/components/monitoring/SystemHealthCard";
import { PerformanceMetricsCard } from "@/components/monitoring/PerformanceMetricsCard";
import { AutoRecoveryCard } from "@/components/monitoring/AutoRecoveryCard";
import { SourceMonitoring } from "@/components/monitoring/SourceMonitoring";

export const MonitoringTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Activity className="h-5 w-5 text-primary" />
        <h2 className="text-2xl font-bold tracking-tight">System Monitoring</h2>
      </div>
      <p className="text-muted-foreground">
        Monitor system health, performance, and automated recovery processes.
      </p>
      
      <Separator />
      
      <Tabs defaultValue="health" className="space-y-4">
        <TabsList>
          <TabsTrigger value="health">System Health</TabsTrigger>
          <TabsTrigger value="performance">Performance</TabsTrigger>
          <TabsTrigger value="sources">Sources</TabsTrigger>
          <TabsTrigger value="recovery">Auto Recovery</TabsTrigger>
        </TabsList>

        <TabsContent value="health" className="space-y-4">
          <SystemHealthCard />
        </TabsContent>

        <TabsContent value="performance" className="space-y-4">
          <PerformanceMetricsCard />
        </TabsContent>

        <TabsContent value="sources" className="space-y-4">
          <SourceMonitoring />
        </TabsContent>

        <TabsContent value="recovery" className="space-y-4">
          <AutoRecoveryCard />
        </TabsContent>
      </Tabs>
    </div>
  );
};